import { getRollbar } from './rollbar/instance';

export function handleError(error: unknown): void {
  const rollbar = getRollbar();

  if (ENV_CONSTANTS.ENV !== 'production' || !rollbar) {
    /* eslint-disable-next-line no-console */
    console.error(error);
    return;
  }

  rollbar.error(error as Error, { stack: error instanceof Error ? error.stack : undefined });
}

export function handleWarning(warning: unknown): void {
  const rollbar = getRollbar();

  if (ENV_CONSTANTS.ENV !== 'production' || !rollbar) {
    /* eslint-disable-next-line no-console */
    console.warn(warning);
    return;
  }

  rollbar.warning(warning as Error);
}
